import React from "react";
import "./style.css"
import { NavLink } from "react-router-dom";
function NotFound() {
  return (
    <section class="page_404 w-full h-screen m-auto">
      <div class="container m-auto">
        <div class="row">
          <div class="col-sm-12 ">
            <div class="col-sm-10 col-sm-offset-1  text-center">
              <div class="four_zero_four_bg">
                <h1 class="text-center ">404</h1>
              </div>

              <div class="contant_box_404">
                <h3 class="h2 text-5xl">مسیری پیدا نشد !!!</h3>

                {/* <a href="/#/login" class="link_404 mt-4 rounded-lg shadow-lg text-xl">
                  برو به لاگین
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default NotFound;
